import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Collection } from '../../../../collection'
import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'
import { State } from '../state'

export const resetOnContextChange = store.reducers.extra(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    collection: Collection<TTypeParams>,
  ) =>
    new store.reducers.ExtraReducer({
      on: [collection.feature.actions.changeContext],
      reduce: (): State<TTypeParams> => State.INITIAL,
    }),
)
